import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#243353",
      light: "#60a5fa",
      dark: "#1d4ed8",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#64748b",
      light: "#94a3b8",
      dark: "#475569",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f7f6f9",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#292e34ff",
      secondary: "#6b7280",
    },
    divider: "rgba(0, 0, 0, 0.05)",
  },
  typography: {
    fontFamily: "'Inter', 'Space Grotesk', sans-serif",

    h1: { fontWeight: 700, letterSpacing: "0.3px" },
    h2: { fontWeight: 700, letterSpacing: "0.3px" },
    h3: { fontWeight: 600, letterSpacing: "0.3px" },
    h4: { fontWeight: 600, letterSpacing: "0.3px" },
    h5: { fontWeight: 600, letterSpacing: "0.3px" },
    h6: { fontWeight: 600, letterSpacing: "0.3px" },

    body1: { fontWeight: 500, letterSpacing: "0.3px" },
    body2: { fontWeight: 500, letterSpacing: "0.3px" },
    caption: { fontWeight: 500, letterSpacing: "0.3px" },

    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.3px" },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f7f6f9",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: 4,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.03)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: "1px solid #E5E7EB",
          backgroundColor: "#FFFFFF", // White sidebar as requested
          boxShadow: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
          color: "#111827",
          boxShadow: "none",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          margin: "4px 12px",
          padding: "10px 16px",
          transition: "all 0.2s ease",
          "&.Mui-selected": {
            backgroundColor: "transparent",
            color: "#243353",
            "&:hover": {
              backgroundColor: "rgba(37, 99, 235, 0.04)",
            },
            "& .MuiListItemIcon-root": {
              color: "#243353",
            },
            "& .MuiListItemText-primary": {
              fontWeight: 700,
            },
          },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.02)",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 40,
          color: "#64748b",
        },
      },
    },
  },
});

export default theme;
